// import {location,ulogin} from '../../api/login';
const user = {
  state: {
    baseUrl: "http://211.157.148.82:8080",
    scrollTop: 0,
    uid: null,
    accesstoken: null,
    sessionToken: null,
    roomId: null,
    locale: null,
    cid: null,
    logInfo: {
      roomId: null,
      userId: null,
      userName: null,
      development: process.env.type,
      platform: "web_yunshi",
      logName: "Web_云视会中",
    },
    liveInfo: [],
    phoneJoinedList: [], //电话会议已入会列表
    addressList: [],
    mgid: null, //分组id
    mainHostId: null, //主组主持人id
    joinTid: "0", //已经加入的组Id
    groupMainInfo: {
      //主组群信息：用于返回主组参数
      gid: null,
      gcid: null,
    },
    groupPermission: null, ///是否有分组权限
    groupStatus: -1, //组状态，1：已开始 0：未开始 2：已结束    -1未创建
    modeJoin: false, //是否允许自由选择：默认是false不允许
    mainRoomId: null, //主会场的roomId
    mainRoomStatus:null,
    mainHostName:null,//主会场主持人
  },
  mutations: {
    /*全局设置滚动的高度*/
    setScrollTop(state, scrollTop) {
      state.scrollTop = scrollTop;
    },
    /**全局设置uid**/
    setUserId(state, uid) {
      state.uid = uid;
    },
    /**全局设置cid**/
    setCid(state, cid) {
      state.cid = cid;
    },
    /*全局设置accesstoken*/
    setAccesstoken(state, accesstoken) {
      state.accesstoken = accesstoken;
    },
    /**全局设置sessionToken**/
    setSessionToken(state, sessiontoken) {
      state.sessionToken = sessiontoken;
    },
    /**设置roomId*/
    setRoomId(state, roomId) {
      state.roomId = roomId;
    },
    setLocale(state, locale) {
      state.locale = locale;
    },
    SetLogInfo(state, info) {
      for (let log in info) {
        // if (state.logInfo[log]) {
        state.logInfo[log] = info[log];
        // }
      }
    },
    setLiveInfo(state, info) {
      state.liveInfo = info;
    },
    setJoinedList(state, info) {
      state.phoneJoinedList = info;
    },
    setAddressList(state, info) {
      state.addressList = info;
    },
    setMgid(state, info) {
      state.mgid = info;
    },
    setMainHostId(state, info) {
      state.mainHostId = info;
    },
    setJoinTid(state, info) {
      state.joinTid = info;
    },
    setMainGroup(state, info) {
      state.groupMainInfo = info;
    },
    setGroupPermission(state, info) {
      state.groupPermission = info;
    },
    setGroupStatus(state, info) {
      state.groupStatus = info;
    },
    setmodeJoin(state, info) {
      state.modeJoin = info;
    },
    setMainRoomId(state, info) {
      state.mainRoomId = info;
    },
    setMainRoomStatus(state,info){
      state.mainRoomStatus = info
    },
    setMainHostName(state,info){
      state.mainHostName  = info
    }
  },
  actions: {
    location({ commit }, positionData) {
      return new Promise((resolve, reject) => {
        location(positionData)
          .then((response) => {
            resolve(response);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    ulogin({ commit }, loginData) {
      return new Promise((resolve, reject) => {
        //将用户名密码加密在header中处理
        ulogin(loginData)
          .then((response) => {
            // localStorage.setItem('userInfo',JSON.stringify(response.user))
            resolve(response);
          })
          .catch((err) => {
            reject(err);
            console.log(err);
          });
      });
    },
    //登出
    logout({ commit }) {
      return new Promise((resolve) => {
        localStorage.clear();
        resolve();
      });
    },
  },
};
export default user;
